import { PayerSettings } from "@wingspanhq/wingspan-api-sdk";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";

export const selectorDefaultCurrency = (payerSettings?: PayerSettings) =>
  (payerSettings?.defaultAccountCurrency as Currency | undefined) ||
  Currency.USD;
